<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-clipboard-outline" inline class="ml-0 px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>

      <v-btn
        id="btn-novo-relatorio"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$emit('opendialog')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVO RELATÓRIO
      </v-btn>

      <v-text-field
        id="relatorios-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-relatorios ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Relatório" />
      <v-divider class="mt-10" />
      <v-data-table
        class="relatorios-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :page.sync="page"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        :loading="loading"
        no-data-text="Nenhum relatório disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.finished_at`]="{ item }">
          {{ item.finished_at | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.linhas`]="{ item }">
          {{ item.linhas | parseNumberToDecimalBR(0, 0) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-rel"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadSpreadSheet(item.id, 'xlsx', item.nome)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-rel"
            :class="['RELATORIO', 'CUSTOMIZADA'].includes(item.tipo) || !canEditItem(item) ? 'cursor-block' : ''"
            :disabled="['RELATORIO', 'CUSTOMIZADA'].includes(item.tipo) || !canEditItem(item)"
            :title="
              ['RELATORIO', 'CUSTOMIZADA'].includes(item.tipo)
                ? 'relatórios criados a partir de modelos ou customizados não podem ser editados'
                : ''
            "
            color="gray"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="editarRelatorio(item.id)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            id="action-favoritar-rel"
            class="ml-n1 px-1"
            :color="item.favorito == '1' ? 'primary' : 'gray'"
            min-width="0"
            fab
            icon
            x-small
            @click="favoritar(item)"
          >
            <v-icon small>mdi-star</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-rel"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="item.status == 'SUCESSO'" @click="visualizarRelatorio(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-eye-outline</v-icon>
                  Visualizar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id, 'recharge')">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicarItem(item.id, 'recharge')">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="userIsAdmin" @click="redirectToPageVisualizarSql(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-key</v-icon>
                  Visualizar SQL
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.status == 'SUCESSO'"
                @click="
                  item.status_exportar_csv_como == 'SUCESSO'
                    ? openDialogDownloadOptions(item.id)
                    : downloadSpreadSheet(item.id, 'csv', item.nome)
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-download</v-icon>
                  Baixar CSV
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.status == 'SUCESSO'"
                :disabled="disabledExportarCsvComoToRelatorio(item.id)"
                @click="openDialogExportarCsvComo(item)"
              >
                <v-list-item-title :loading="true">
                  <v-icon small :disabled="disabledExportarCsvComoToRelatorio(item.id)">mdi-download-circle-outline</v-icon>
                  Exportar CSV como
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="userIsAdmin && ['SUCESSO', 'FALHA'].includes(item.status)" @click="openDialogAgendamento(item)">
                <v-list-item-title :loading="true">
                  <v-icon small>mdi-refresh</v-icon>
                  Atualização de Dados
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="userIsAdmin && ['SUCESSO', 'FALHA'].includes(item.status)"
                @click="openDialogConsultaInterna(item)"
              >
                <v-list-item-title :loading="true">
                  <v-icon small>mdi-cog</v-icon>
                  Consulta Interna
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-row>
            <v-col cols="2" class="py-0">
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute"
                color="primary"
                label="Consultas Internas"
                dense
                @change="$emit('switchConsutasInternasChanged', $event)"
              />
            </v-col>
            <v-col cols="2" class="py-0">
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute"
                color="primary"
                label="Exibir Expirados"
                dense
                @change="$emit('switchProcessamentosExpirados', $event)"
              />
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id, 'recharge')"
    >
      <template slot="title">Deletar Relatorio #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o relatório
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-exportar-csv-como
      v-if="dialoExportarCsvComoData"
      :dialog.sync="dialogExportarCsvComo"
      :relatorio="dialoExportarCsvComoData"
      @submitTriggered="gerarCustomCSV($event)"
      @processamentoFinalizado="(openDialogDownloadOptions($event), (dialoExportarCsvComoData = null))"
    />
    <dialog-download-options
      :dialog.sync="dialogDownloadOptions"
      @submitTriggered="downloadSpreadSheet(dialogDownloadOptionsData.id, $event, dialogDownloadOptionsData.nome)"
    />
    <dialog-consulta-interna
      v-if="dialogConsultaInterna"
      :dialog.sync="dialogConsultaInterna"
      :data="dialogConsultaInternaData"
      @submitTriggered="modificarConsultaInterna($event)"
    />
    <dialog-agendamento
      v-if="dialogAgendamento"
      :dialog.sync="dialogAgendamento"
      :data="dialogAgendamentoData"
      @submitTriggered="agendarRelatorio($event)"
    />
    <dialog-detalhes title="Detalhes do Relatório" :show-dialog="dialogDetalhes" @changeValue="dialogDetalhes = $event">
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          :mobile-breakpoint="0"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </dialog-detalhes>
  </v-container>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService.js';
  import downloadSpreadSheet from '@/mixins/downloadSpreadSheet';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogExportarCsvComo: () => import('@/components/relatorios/DialogExportarCsvComo.vue'),
      DialogDownloadOptions: () => import('@/components/relatorios/DialogDownloadOptions.vue'),
      DialogConsultaInterna: () => import('@/components/relatorios/DialogConsultaInterna.vue'),
      DialogAgendamento: () => import('@/components/relatorios/DialogAgendamento.vue'),
      DialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },

    mixins: [downloadSpreadSheet, powerupsActionsMixins, dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: 'Tabela'
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: [
      'opendialog',
      'switchConsutasInternasChanged',
      'switchProcessamentosExpirados',
      'actionVisualizarTriggered',
      'recharge'
    ],

    data: () => ({
      powerupService: RelatoriosService,
      powerupEntityName: 'Relatório',
      page: 1,
      search: undefined,
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'finished_at'
        },
        {
          text: 'Linhas',
          value: 'linhas'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      dialogDelete: false,
      dialogExportarCsvComo: false,
      dialogDownloadOptions: false,
      dialogDeleteData: { id: undefined, nome: undefined },
      dialoExportarCsvComoData: null,
      dialogDownloadOptionsData: { id: undefined, nome: undefined },
      dialogConsultaInterna: false,
      dialogConsultaInternaData: null,
      dialogAgendamento: false,
      dialogAgendamentoData: null
    }),

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      openDialogDetalhes(item) {
        this.dialogDetalhesData = [
          {
            parametro: 'ID',
            valor: item.id
          },
          {
            parametro: 'Nome',
            valor: item.nome
          },
          {
            parametro: 'Usuário',
            valor: item.usuario
          },
          {
            parametro: 'Executado por',
            valor: item.executor || '-'
          },
          {
            parametro: 'Tipo',
            valor: item.tipo
          },
          {
            parametro: 'Iniciado em',
            valor: this.formatDateHour(item.started_at) || '-'
          },
          {
            parametro: 'Finalizado em',
            valor: this.formatDateHour(item.finished_at) || '-'
          },
          {
            parametro: 'Linhas',
            valor: item.linhas ?? '-'
          }
        ];

        this.dialogDetalhes = true;
      },

      openDialogDelete(id, nome) {
        this.dialogDeleteData = { id: id, nome: nome };
        this.dialogDelete = true;
      },

      openDialogExportarCsvComo(relatorio) {
        this.dialoExportarCsvComoData = relatorio;
        this.dialogExportarCsvComo = true;
      },

      openDialogDownloadOptions(relatorioID) {
        const item = this.items.find((relatorio) => relatorio.id === relatorioID);
        this.dialogDownloadOptionsData = { id: relatorioID, nome: item ? item.nome : '' };
        this.dialogDownloadOptions = true;
      },

      editarRelatorio(id) {
        this.$router.push(`edit/${id}`);
      },

      visualizarRelatorio(id) {
        this.$emit('actionVisualizarTriggered', {
          ativo: true,
          relatorio_id: id
        });
      },

      redirectToPageVisualizarSql(id) {
        this.$router.push(`visualizar-sql/${id}`);
      },

      favoritar(item) {
        RelatoriosService.favoritar(item.id)
          .then(() => {
            return (item.favorito = item.favorito == '1' ? false : true);
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao tentar favoritar/desfavoritar.', '', {
              position: 'topRight'
            });
          });
      },

      gerarCustomCSV(data) {
        RelatoriosService.gerarCustomCSV(data)
          .then(() => {
            this.$emit('recharge');
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao tentar gerar arquivo CSV customizável.', '', { position: 'topRight' });
          });
      },

      disabledExportarCsvComoToRelatorio(id) {
        if (this.dialoExportarCsvComoData) {
          return this.dialoExportarCsvComoData.id === id ? false : true;
        }

        return false;
      },

      openDialogConsultaInterna(relatorio) {
        this.dialogConsultaInternaData = {
          id: relatorio.id,
          nome: relatorio.nome
        };
        this.dialogConsultaInterna = true;
      },

      modificarConsultaInterna(data) {
        RelatoriosService.setConsultaInterna(data.id, data.status)
          .then(() => {
            this.dialogConsultaInterna = false;
            this.$toast.success('Status de consulta interna alterado com sucesso', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            this.$toast.error('Erro ao alterar status de consulta interna', '', {
              position: 'topRight'
            });
            console.log(error);
          });
      },

      openDialogAgendamento(relatorio) {
        this.dialogAgendamentoData = { id: relatorio.id, cron: relatorio.cron };
        this.dialogAgendamento = true;
      },

      agendarRelatorio(data) {
        RelatoriosService.agendar(data.id, data.cron)
          .then(() => {
            this.dialogAgendamento = false;
            this.$emit('recharge');
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao tentar agendar atualização de dados de relatório.', '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .relatorios-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .relatorios-table table tr td:nth-child(6),
    .relatorios-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }
  @media screen and (max-width: 480px) {
    .bs-relatorios {
      width: 195.14px !important;
    }
  }
  .relatorios-table .v-data-table__wrapper {
    overflow-x: visible;
    overflow-y: visible;
  }
  .text-linha-column {
    font-size: 0.95rem;
    font-weight: normal;
    color: #e5502c;
  }
  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
